// extracted by mini-css-extract-plugin
export default {"App":"getting-started_App__Bzv0j"};